var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCompltedTaskIc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 114,
    height: 114,
    viewBox: "0 0 114 114",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_246609",
    "data-name": "Group 246609",
    transform: "translate(-154.876 -74.876)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_4",
    "data-name": "Ellipse 4",
    cx: 57,
    cy: 57,
    r: 57,
    transform: "translate(154.876 74.876)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "check-badge-svgrepo-com_3_",
    "data-name": "check-badge-svgrepo-com (3)",
    transform: "translate(167.019 87.019)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_47",
    "data-name": "Path 47",
    d: "M35.842,8.336a14.078,14.078,0,0,1,22.911,0l.894,1.251a4.692,4.692,0,0,0,4.336,1.936l3.984-.443A14.078,14.078,0,0,1,83.514,26.628l-.443,3.984a4.692,4.692,0,0,0,1.936,4.337l1.252.894a14.078,14.078,0,0,1,0,22.911l-1.252.894a4.692,4.692,0,0,0-1.936,4.336l.443,3.984A14.078,14.078,0,0,1,67.968,83.514l-3.984-.443a4.692,4.692,0,0,0-4.336,1.936l-.894,1.252a14.078,14.078,0,0,1-22.911,0l-.894-1.252a4.692,4.692,0,0,0-4.337-1.936l-3.984.443A14.078,14.078,0,0,1,11.081,67.968l.443-3.984a4.692,4.692,0,0,0-1.936-4.336l-1.251-.894a14.078,14.078,0,0,1,0-22.911l1.251-.894a4.693,4.693,0,0,0,1.936-4.337l-.443-3.984A14.078,14.078,0,0,1,26.628,11.081l3.984.443a4.693,4.693,0,0,0,4.337-1.936ZM64.694,34.594a4.693,4.693,0,0,1,0,6.636L46.773,59.151a5.894,5.894,0,0,1-8.336,0L29.9,50.616a4.693,4.693,0,0,1,6.636-6.636l6.067,6.067L58.058,34.594A4.693,4.693,0,0,1,64.694,34.594Z",
    transform: "translate(-2.441 -2.441)",
    fill: "#153c42",
    fillRule: "evenodd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompltedTaskIc);
export default __webpack_public_path__ + "static/media/complted_task_ic.49ddef6bb9fd545a0ee3c1f883959404.svg";
export { ForwardRef as ReactComponent };